/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantVlcrProvisionEdr } from './tenantVlcrProvisionEdr';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ByolEdr } from './byolEdr';


export interface TenantRansomwareRecoveryActivationSpec { 
    vlcr_provider?: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    vlcr_region?: string;
    byol?: ByolEdr;
    vlcr_provisioned?: TenantVlcrProvisionEdr;
}
export namespace TenantRansomwareRecoveryActivationSpec {
}


